import { Checkbox, Typography } from "@mui/material";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { ColorScheme } from "../../../Themes/ColorScheme";
import { SortingArrow } from "../../Common/SortingArrow";

export const SortingOptions = ({ sort, setSort, selectAllPressed, allSelected }) => {
	// Define more options if needed or comment out to remove, id has to match server response
	const { t } = useTranslation();
	const sortingOptions = [
		{ label: t("key.user_name"), id: "user_name" },
		{ label: t("key.user_description"), id: "description" },
		{
			label: t("key.user_phone_short") + " /\n" + t("key.user_license_plate_short"),
			id: "phone"
		},
		{
			label: t("key.effective_time_duration"),
			id: "end" // we check and sort only by end date here. Need to improve this, if we want to sort by start and end date and then by time from single function, which may be a bit confusing to user without proper indicators which value is being sorted and how
		},
		{
			label: t("key.status"),
			id: "access_status"
		}
	];

	const sortingOptionsMobile = [
		{ label: t("key.user_name"), id: "user_name" },
		{
			label: t("key.effective_time_duration"),
			id: "end" // we check and sort only by end date here. Need to improve this, if we want to sort by start and end date and then by time from single function, which may be a bit confusing to user without proper indicators which value is being sorted and how
		}
	];

	function changeSort(id) {
		if (sort.split(" ")[0] === id) {
			if (sort.split(" ")[1] === "ASC") {
				setSort(id + " DESC");
			} else {
				setSort(id + " ASC");
			}
		} else {
			setSort(id + " ASC");
		}
	}

	function isAscending() {
		return sort.split(" ")[1] === "ASC";
	}

	function isSorted(id) {
		return sort.split(" ")[0] === id;
	}

	return (
		<div
			style={{
				display: "flex",
				flexWrap: isMobile ? "wrap" : "nowrap",
				justifyContent: "space-between",
				/* width: "100%", */
				boxSizing: "border-box",
				backgroundColor: ColorScheme.primary
			}}
		>
			<div style={{ width: "50px", maxWidth: "50px", minWidth: "50px", display: "flex", alignItems: "center", justifyContent: "center", width: "50px" }}>
               <Checkbox
				checked={allSelected}
				onChange={(e) => selectAllPressed(e.target.checked)}
				disableRipple
				sx={{
					color: ColorScheme.lightGrey,             // perus reunus
					borderColor: ColorScheme.lightGrey,
					borderRadius: "4px",
					"&.Mui-checked": {
					color: ColorScheme.secondary,
					backgroundColor: ColorScheme.primary,
					borderColor: ColorScheme.secondary, // pidetään sama reunus
					border: "0px solid"
					},
					"&.MuiCheckbox-root": {
					padding: "0px",
					},
					"&:hover": {
					borderColor: ColorScheme.lightGrey,
					},
				}}
				/>
            </div>
			{!isMobile &&
				sortingOptions.map((option) => (
					<div
						key={option.id}
						style={{
							display: "flex",
							width: "calc((100% - 50px) / 5)",
							padding: "15px",
							paddingLeft: "20px",
							borderRight:
								"1px solid" +
								ColorScheme.secondary,
							...(isMobile && {
								borderBottom:
									"1px solid" +
									ColorScheme.secondary
							}),
							alignItems: "center",
							cursor: "pointer",
							boxSizing: "border-box"
						}}
						onClick={() => changeSort(option.id)}
					>
						<div
							style={{
								display: "flex",
								flexDirection: "row",
								alignItems: "center",
								justifyContent: "space-between",
								width: "100%"
							}}
						>
							<Typography
								fontSize="13px"
								sx={{ wordBreak: "break-word" }}
							>
								{option.label}
							</Typography>
							{isSorted(option.id) ? (
								<div style={{ width: "16px", height: "19px" }}>
									<SortingArrow order={isAscending()} />
								</div>
							) : (
								<div style={{ width: "16px" }} />
							)}
						</div>
					</div>
				))}
			{isMobile &&
				sortingOptionsMobile.map((option) => (
					<div
						key={option.id}
						style={{
							display: "flex",
							width: "calc((100% - 50px) / 2)",
							padding: "15px",
							paddingLeft: "20px",
							borderRight:
								"1px solid" +
								ColorScheme.secondary,
							...(isMobile && {
								borderBottom:
									"1px solid" +
									ColorScheme.primary
							}),
							alignItems: "center",
							cursor: "pointer",
							boxSizing: "border-box"
						}}
						onClick={() => changeSort(option.id)}
					>
						<div
							style={{
								display: "flex",
								flexDirection: "row",
								alignItems: "center",
								justifyContent: "space-between",
								width: "100%"
							}}
						>
							<Typography
								fontSize="13px"
								sx={{ wordBreak: "break-word" }}
							>
								{option.label}
							</Typography>
							{isSorted(option.id) ? (
								<div style={{ width: "16px", height: "19px" }}>
									<SortingArrow order={isAscending()} />
								</div>
							) : (
								<div style={{ width: "16px" }} />
							)}
						</div>
					</div>
				))}
		</div>
	);
};
